// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1haIF","select":"Header_select__2c0gK","clinic":"Header_clinic__fygis"};